import { render } from "./NewsNotice.vue?vue&type=template&id=0f84e81f&scoped=true"
import script from "./NewsNotice.vue?vue&type=script&lang=js"
export * from "./NewsNotice.vue?vue&type=script&lang=js"

import "./NewsNotice.vue?vue&type=style&index=0&id=0f84e81f&scoped=true&lang=css"

import exportComponent from "/Volumes/directory/IdeaProjects/Macau-Double-Color-Ball/Macau-Double-Color-Ball_Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f84e81f"]])

export default __exports__